<template>
  <v-dialog v-model="openPopup" width="360px" persistent>
    <div class="layerPopup smsLayer" :class="{'layerDimmed': isDimmed}">
      <div class="layerContent">
        <div class="callLayerCon">
          <div class="sandMsgCon">
            <div class="msgBox">
              <div class="btnsBox">
                <div class="btns">
                  <v-btn
                    v-for="(k, i) in keyNumbers"
                    :key="i"
                    :style="{color: k === '*' || k === '#' ? '#F4F4F4' : '#121212'}"
                    @click="clickPhoneNumber(k)"
                    flat
                  >
                    {{ k }}
                  </v-btn>
                </div>
                <div class="phoneNumberInp">
                  <p>受信番号</p>
                  <v-text-field
                    v-model="phoneNumber"
                    @keyup="phoneNumberCheck(phoneNumber)"
                    @keydown="phoneNumberCheck(phoneNumber)"
                    class="UXinput UXicon-edit outline"
                    hide-details
                    outline
                    solo
                    @keyup.enter.exact="makeCall"
                  ></v-text-field>
                </div>
              </div>
              <div class="phoneNumberInp not-table">
                <p>発信番号</p>
                <div class="select">
                  <v-select
                    v-if="callMode === 'KT'"
                    v-model="reception"
                    :items="receptionList"
                    :item-text="item => item.serviceName + ' (' + item.serviceNumber + ')'"
                    item-value="serviceNumber"
                    auto-select-first="true"
                    class="UXselect"
                    color="#ff8c8c"
                    hide-details
                    outline
                    solo
                    no-data-text="データがありません。"
                  ></v-select>
                  <v-select
                    v-else
                    v-model="reception"
                    :items="receptionList"
                    item-text="representativeNumber"
                    item-value="representativeNumber"
                    auto-select-first="true"
                    class="UXselect"
                    color="#ff8c8c"
                    hide-details
                    outline
                    solo
                    no-data-text="データがありません。"
                  >
                  </v-select>
                </div>
              </div>
              <div class="callBtn">
                <v-btn fab @click="makeCall"><i class="UXicon-call"></i></v-btn>
                通話
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="dimmedBox" v-if="isDimmed">
        <dl>
          <dt>{{title}}</dt>
          <dd v-html="dimmedContext"></dd>
        </dl>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import helper from '@/util/helpers'
import apiEvent from '@/util/call/apiEvent'
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: 'CallLayer',
  props: ['open'],
  data () {
    return {
      openPopup: false,
      phoneNumber: '',
      reception: '',
      receptionList: [],
      logDwonloadKey: '',
      keyNumbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
      isDimmed: true,
      isUseCall: false,
      brandId: '',
      title: '',
      dimmedContext: '',
      // marginLeft: '-117px',
      callType: {
        KT: 'KT_CALL',
        NEOMECCA: 'CALL'
      }
    }
  },
  computed: {
    ...mapGetters([
      'callBrandId',
      'currentBrandId',
      'agentMappingBrandViews',
      'isExistCallAgent',
      'enabledCallAgent',
      'IS_VALID_TEL',
      'IS_TEL_ING',
      'callMode'
    ])
  },
  watch: {
    open (val) {
      this.openPopup = val
      if (val) {
        this.setData()
        this.checkAvailability()
      }
    }
  },
  methods: {
    ...mapMutations([
      'changeCustomerPhoneNumber'
    ]),
    close () {
      this.logDwonloadKey = ''
      this.$parent.showCallPopup = false
    },
    setData () {
      this.phoneNumber = ''
      this.reception = ''
      this.isUseCall = false
      this.isDimmed = false
      this.title = ''
      this.dimmedContext = ''
      this.brandId = this.agentMappingBrandViews.sort((left, right) => left.brandId - right.brandId)[0].brandId
    },
    checkAvailability () {
      this.axios.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.currentBrandId || this.brandId,
          moduleName: 'CALL',
          channelName: this.callType[this.callMode]
        }
      }).then(result => {
        if (result.data.code === 0) {
          this.callMode === 'KT' ? this.getKtServiceList() : this.fetchReceptionList()
        } else {
          this.isUseCall = true
        }
      }).then(() => this.setDimmedContext())
    },
    setDimmedContext () {
      if (this.isUseCall) {
        this.isDimmed = true
        this.title = '使用中のサービスではありません。'
        this.dimmedContext = `<span>ブランド設定 > 'チャネル連動' で<br/><span style="font-weight: 700">'コール'</span> 使用を設定してください。<span>`
      } else if (!this.isExistCallAgent || !this.enabledCallAgent) {
        this.isDimmed = true
        this.title = '使用中のサービスではありません。'
        this.dimmedContext = `<span>コール相談管理 > 'コールオペレーター接続' で<br/><span style="font-weight: 700">'コール相談'</span> 使用を設定してください。<span>`
      } else if (!this.IS_VALID_TEL) {
        this.isDimmed = true
        this.title = 'サービスエラー'
        this.dimmedContext = '<span>登録されていない内線番号です。<br/>内線番号を再設定してログインしてください。</span>'
      } else if (!this.IS_TEL_ING) {
        this.isDimmed = true
        this.title = 'サービスエラー'
        this.dimmedContext = '<span>すでに登録されている内線番号です。<br/>内線番号を確認してから更新してください。</span>'
      }
    },
    getKtServiceList () {
      this.$http.get(`/api/brand/${this.currentBrandId}/callserviceinfo?status=ENABLE`).then(result => {
        if (result.data.code === 0) {
          this.receptionList = result.data.data
          this.reception = this.receptionList[0]
        } else {
          this.$toasted.error(result.data.message)
        }
      }).catch(err => {
        this.$toasted.error(err)
      })
    },
    fetchReceptionList () {
      this.axios.get(`/gateway/call/brand/listSub/${this.callBrandId}`)
        .then(result => {
          if (result.data.code === 0) {
            const data = result.data.data
            this.receptionList = data.map(item => {
              return {calledNumber: item.rmk, representativeNumber: item.rmk2, name: item.codeNm}
            })
            this.reception = this.receptionList[0].representativeNumber
          }
        })
    },
    isValidCall () {
      if (!helper.isStringValid(this.phoneNumber)) {
        this.$toasted.error('顧客の電話番号がありません。')
        return false
      }

      this.serviceNumber = this.callMode === 'KT' ? this.reception.serviceNumber || this.reception : this.reception
      if (!helper.isStringValid(this.serviceNumber)) {
        this.$toasted.error('発信番号がありません。')
        return false
      }

      return true
    },
    makeCall () {
      this.$logReport.download(this.logDwonloadKey).then(() => {
        return false
      }).catch(() => {
        if (!this.isValidCall()) return

        const number = helper.outCommingPhoneCovert(this.phoneNumber.replace('-', ''))
        this.callMode === 'KT' ? apiEvent.makeCall(number, this.serviceNumber) : apiEvent.makeCall(number, this.reception)
        this.changeCustomerPhoneNumber(this.phoneNumber.replace('-', ''))
        this.close()

        if (this.$route.fullPath === '/operation') {
          this.$router.push('/call/operation')
        }
      })
    },
    clickPhoneNumber (num) {
      this.logDwonloadKey = this.logDwonloadKey + num
      if (num !== '*' && num !== '#') {
        this.phoneNumber = this.phoneNumber + num
      }
    },
    phoneNumberCheck (phone) {
      const regexp = /[^0-9]/g
      this.phoneNumber = phone.replace(regexp, '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/callOperation/components/CallLayer.vue